import "../styles/Navbar.css";

function Navbar() {
  const handleLogoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scrolling
    });
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="logo-container">
          <img src="/new_logo.png" alt="Nyayom Legal Services Logo" className="logo-img" onClick={handleLogoClick} />
        </div>

        {/* Menu */}
        <ul className="nav-links">
          <li><a href="#about">About Us</a></li>
          <li><a href="#foundation">Our Foundation</a></li>
          <li><a href="#who-we-are">Who We Are</a></li>
          <li><a href="#practices">Our Practices</a></li>
          <li><a href="#blog">Blog</a></li>
          <li><a href="#contact">Contact Us</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
